import React, { PureComponent } from 'react';

import StatusSummaryButton from '../status/statusSummaryButton.jsx';
import { trackEvent } from '../../services/trackingService';

class StartSafeTrade extends PureComponent {
    componentDidMount() {
        trackEvent('trade.display-start-safe-payment-button');
    }

    render() {
        return (
            <StatusSummaryButton href="/start-trygg-betaling" withOnboarding>
                Start Trygg betaling
            </StatusSummaryButton>
        );
    }
}

export default StartSafeTrade;



// WEBPACK FOOTER //
// ./safeTrade/buyer/startSafeTrade.jsx